<div class="side-nav-wrapper flex-area">
    <mat-toolbar>
        <span>Notifications</span>
        <span class="example-spacer"></span>
        <!-- <button mat-button aria-label="Read All Notifications">
            Mark all as read
        </button> -->
        <button mat-icon-button aria-label="Close" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar>
      <div class="toolbar-controls">
        <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
            <mat-icon matPrefix>search</mat-icon>
            <input
                matInput
                type="text"
                placeholder="Search cameras or sites"
                [value]="searchTerm()"
                (input)="updateSearchTerm($event)"
                aria-label="Search notifications" />
        </mat-form-field>
        <button
            class="sort-toggle"
            mat-icon-button
            [attr.aria-label]="sortLabel()"
            [matTooltip]="sortLabel()"
            (click)="toggleSortDirection()">
            <mat-icon class="material-symbols-outlined medium">{{sortIcon()}}</mat-icon>
        </button>
      </div>
      <div class="alert-content-wrapper">
        @for (notification of displayedNotifications(); track notification.trackId) {
            <mat-card class="alert">
                @switch (notification.type) {
                    @case ("CAMERA_DOWN") {
                        <h3>Camera Down</h3>
                        <p>
                            {{notification.site_name}}
                        </p>
                        <p>
                            {{notification.camera_name}}
                        </p>
                        @if (notification.timestamp) {
                            <p>
                                Offline since {{notification.timestamp | date:'dd MMM, HH:mm'}}
                            </p>
                        }
                    }
                }


            </mat-card>
        } @empty {
            <p class="empty-state">No notifications</p>
        }
      </div>
</div>
